import React, { useEffect, useState } from 'react';

const flyers = [
  {
    src: '/images/flyer_burial_plots.jpg',
    title: 'Burial Plot Purchase',
    alt: 'Garden of Peace Muslim Cemetery flyer announcing a limited opportunity to purchase burial plots for $1,000 per plot.',
  },
];

const PopUp = ({ show, onClose }) => {
  const [expandedFlyer, setExpandedFlyer] = useState(null);

  useEffect(() => {
    if (!show) {
      setExpandedFlyer(null);
    }
  }, [show]);

  useEffect(() => {
    if (!show) return undefined;

    const handleKeyDown = event => {
      if (event.key !== 'Escape') return;

      if (expandedFlyer) {
        setExpandedFlyer(null);
      } else {
        onClose();
      }
    };

    document.addEventListener('keydown', handleKeyDown);
    return () => document.removeEventListener('keydown', handleKeyDown);
  }, [expandedFlyer, onClose, show]);

  if (!show) {
    return null;
  }

  return (
    <div className="modal modal--flyer" onClick={onClose}>
      <div
        className={`modal-content modal-content--flyer${expandedFlyer ? ' is-expanded' : ''}`}
        role="dialog"
        aria-modal="true"
        aria-label={expandedFlyer ? `${expandedFlyer.title} flyer` : 'Garden of Peace important updates'}
        onClick={event => event.stopPropagation()}
      >
        {expandedFlyer ? (
          <>
            <button
              className="close"
              type="button"
              aria-label="Back to popup"
              onClick={() => setExpandedFlyer(null)}
            >
              &times;
            </button>
            <img className="modal-flyer modal-flyer--expanded" src={expandedFlyer.src} alt={expandedFlyer.alt} />
          </>
        ) : (
          <>
            <button className="close" type="button" aria-label="Close popup" onClick={onClose}>&times;</button>

            <div className="modal-announcement">
              <p className="modal-greeting">Assalamualaikum,</p>
              <section className="modal-announcement-section">
                <h2>Burial Plots Are Now Open for Purchase</h2>
                <p>
                  Plot purchases must be completed by <strong>October 30, 2026</strong>. Please read the{' '}
                  <a href="https://sites.google.com/view/gardenofpeace-terms/home" target="_blank" rel="noreferrer">
                    purchase terms and conditions
                  </a>.
                </p>
                <a
                  className="site-button modal-purchase-button"
                  href="https://docs.google.com/forms/d/e/1FAIpQLSei7HKp6l9X9w0UB2FICqfozZEtysfrPg7MLkBk6rFgoeQO0g/viewform?pli=1"
                  target="_blank"
                  rel="noreferrer"
                >
                  Purchase a burial plot
                </a>
              </section>
            </div>

            <div className="modal-flyer-grid" aria-label="Event flyers">
              {flyers.map(flyer => (
                <button
                  className="modal-flyer-card"
                  type="button"
                  key={flyer.src}
                  aria-label={`Expand ${flyer.title} flyer`}
                  onClick={() => setExpandedFlyer(flyer)}
                >
                  <img className="modal-flyer" src={flyer.src} alt={flyer.alt} />
                  <span>{flyer.title}<small>Click to expand</small></span>
                </button>
              ))}
            </div>
          </>
        )}
      </div>
    </div>
  );
};

export default PopUp;
